import ConfirmationModal from 'components/common/ConfirmationMessage';
import { PAGELENGTH } from 'components/common/ListLayout';
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import { usePermissions } from 'layouts/Admin';
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import moment from "moment";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useNavigation } from 'react-router-dom';
import { DashboardSelector } from 'slices/dashboardSlice';
import { dashboardSlice } from 'slices/dashboardSlice';
import { fetchDashboardAppointments } from 'slices/dashboardSlice';
import { getEyeStyle, getBackgroundStyle } from 'components/common/TableColor';
import { SubmitButton as Button } from 'components/common/buttons/SubmitButton';
import InviteInterpreterModal from 'components/common/InviteInterpreterModal';
import momentTz from "moment-timezone";
// import { AcceptActionModal } from './AcceptActionModal';

const ListTable = ({ data, filters, setFilters, setPageLength, searchTerm, setSearchTerm }) => {
    const [currentPage, setCurrentPage] = React.useState(1);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        dispatch(fetchDashboardAppointments(page, { ...filters }));
    };

    const callBack = (dir, sortBy) => {
        dispatch(fetchDashboardAppointments(currentPage, { ...filters, sortBy, sortDirection: dir }));
    };
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { checkPermission } = usePermissions()
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);

    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [declineModal, setDeclineModal] = React.useState(
        {
            show: false,
            item: {}
        }
    );
    const [inviteInterpreter, setInviteInterpreter] = React.useState(
        {
            show: false,
            item: {}
        }
    );
    const [selectedValue, setSelectedValue] = React.useState([10])
    // keep additional filters (date range, status, etc.) here so we can
    // preserve them across fetches (sort/change page/status updates)
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'id',
        sortDirection: 'desc',
    });;
    const [sortFields, setSortFields] = React.useState([]);

    const [actionAccept, setActionAccept] = React.useState({
        show: false,
        item: {}
    });
    const { dashboard, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(DashboardSelector);

    React.useEffect(() => {
        // setSortFields([])
        // Promise.allSettled(
        //     [
        //         dispatch(fetchDashboardAppointments())
        //     ]
        // )
    }, [])

    const handleAddScheduleListPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            // dispatch(fetchDashboardAppointments())
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const showConfirmDialog = () => {
        setDeclineModal(true);
        return
    };
    const hideConfirmDialog = () => {
        setDeclineModal(false);
    }

    const handleDeclineConfirm = () => {
        // dispatch(declineVendorJobs({ schedule_id: declineModal?.item?.id }, submitCallback))
    }


    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };

    // const viewItemButtonRef = React.useRef()



    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {

        // const callBack = (direction, field, donotSort = false) => {
        //     setSortFields((prevConfigArray, nextConfig) => {
        //         let upgradedSortFields = [];
        //         const currentConfig = prevConfigArray.find(config => config.field === field)
        //         if (currentConfig) {
        //             upgradedSortFields = [...prevConfigArray.filter(config => config.field !== field), { field, direction }];
        //         }
        //         else {
        //             upgradedSortFields = [...prevConfigArray, { field, direction }]

        //         }
        //         // !donotSort && dispatch(fetchVendorPendingJobs(currentPage, { sortFields: JSON.stringify(upgradedSortFields), search: searchTerm }))
        //         return upgradedSortFields;
        //     });

        // }

        // const sortDirection = (field) => {
        //     const index = sortFields?.findIndex(config => config.field === field)
        //     if (index > -1) {
        //         const direction = sortFields[index].direction;
        //         return direction
        //     }
        //     return "asc"

        // }

        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchDashboardAppointments(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm, ...filters }))
        }


        return (
            <tr>
                <th>#</th>
                <th>
                    <TableHeaderItem
                        title={t("table.appid")}
                        sortBy="appid"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title={t("table.status")}
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title={t("table.service")}
                        sortBy="type"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title={t("table.date")}
                        sortBy="date"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title={t("table.language")}
                        sortBy="language_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title={t("table.vendor")}
                        sortBy="interpreter_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title={t("table.client")}
                        sortBy="account_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title={t("table.subAccount")}
                        sortBy="subclient_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    {t("table.action")}
                </th>
            </tr>
        )
    }, [t, selectAll, searchTerm, sortFields, currentPage, sortConfig, selectedItems]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            data?.map((item, index) => (
                <AppointmentListItem item={item} index={index} handleAcceptButton={handleAcceptButton} handleDeclineShow={handleDeclineShow} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} handleInviteInterpreter={handleInviteInterpreter} t={t} />
            ))
        )
    }, [selectedItems, data, t]);

    //#endregion


    const handleAcceptButton = React.useCallback((id) => {
        // viewItemButtonRef.current?.click()
        setActionAccept({
            show: true,
            item: { id },
        });

    }, [])


    const handleCloseActionButton = React.useCallback((id) => {
        // viewItemButtonRef?.current?.click()
        setActionAccept({
            show: false,
            item: {}
        })
    }, [])



    const handleDeclineShow = React.useCallback((id) => {
        // viewItemButtonRef.current?.click()
        setDeclineModal({
            show: true,
            item: { id },
        });

    }, [])
    const handleCloseInviteInterpreter = () => {
        setInviteInterpreter(false);
    };
    const handleInviteInterpreter = React.useCallback((item) => {
        setInviteInterpreter({
            show: true,
            item: item,
        });
    }, []);

    return (
        <div className='mt-4'>

            <ListLayout
                heading={t("dashboardAppointment.title")}
                time={false}
                fullMainHead={'ms-3'}
                title=""
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchDashboardAppointments}
                paginationParams={filters}
                selectedItems={selectedItems}
                handleDeclineConfirm={handleDeclineConfirm}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddScheduleListPopUp}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                searchPlaceholder={t("table.searchPlaceholder")}
                addButtonDisabled={true}
                totalPages={totalPages}
                sortConfig={sortConfig}
                noOfItems={total}
                pageLengthChange={setPageLength}
                defaultPageLength={pageLength}
            >

                {/* <button
                    type='button'
                    hidden
                    ref={viewItemButtonRef} data-bs-toggle="modal" data-bs-target="#viewModal" className='display-none'
                /> */}
                {/* <AcceptActionModal item={actionAccept?.item} onClose={handleCloseActionButton} isOpen={actionAccept.show}/> */}

                {declineModal.show && <ConfirmationModal onClose={hideConfirmDialog} isOpen={declineModal?.show} onConfirm={handleDeclineConfirm} confirmationText={t("table.confirmDecline")} />}

            </ListLayout>

            {inviteInterpreter.show && (
                <InviteInterpreterModal
                    isOpen={inviteInterpreter.show}
                    onClose={handleCloseInviteInterpreter}
                    appointment={inviteInterpreter.item}
                // onClose={() =>
                //     setInviteInterpreter({ show: false, item: null })
                // }
                />
            )}
        </div>
    )
}


const AppointmentListItem = React.memo(({
    item, index, handleAcceptButton, handleDeclineShow, current_page, pageLength, checkPermission, handleInviteInterpreter, t

}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    // const rowStyle = item?.confirmation_status === 'link_opened'
    //     ? { background: 'rgb(18 241 168 / 30%)' }
    //     : getBackgroundStyle(item?.status);

    const [, forceTick] = React.useState(0);

    React.useEffect(() => {
        const interval = setInterval(() => {
            forceTick((t) => t + 1);
        }, 30000); // re-check every 30s so red-blink turns on/off live
        return () => clearInterval(interval);
    }, []);

    const rowStyle = useMemo(() => {
    const appointmentTimezone = item?.appointment_details?.timezone?.name; // e.g. "America/New_York"

    // Figure out "now" and "appointment time" IN THE APPOINTMENT'S TIMEZONE
    let minutesDiff = null;
    if (appointmentTimezone && item?.datetime) {
        const appointmentTime = momentTz.tz(item.datetime, appointmentTimezone);
        const nowInApptTz = momentTz.tz(appointmentTimezone);
        minutesDiff = appointmentTime.diff(nowInApptTz, 'minutes');
    } else if (item?.datetime) {
        const appointmentTime = moment(item.datetime);
        const now = moment();
        minutesDiff = appointmentTime.diff(now, 'minutes');
    }

    const hasConfirmationSent = !!(item?.confirmation_sent_1hr_at || item?.confirmation_sent_24hr_at);
    const confirmationStatusNull = item?.confirmation_status === null || item?.confirmation_status === undefined;

    // Default: pure status-based color (this is what gets used whenever
    // none of the special highlight conditions below apply)
    let style = getBackgroundStyle(item?.status);
    let blinkClass = "";
    let highlightType = null;

    // 1) HIGHEST PRIORITY: link_opened -> always green, regardless of anything else
    if (item?.confirmation_status === 'link_opened') {
        style = { background: 'rgb(18 241 168 / 30%)' };
        highlightType = 'green';
    }
    // 2) Only consider red/yellow timing highlight when:
    //    - confirmation_status is still null (nothing happened yet)
    //    - AND at least one confirmation email/notification has actually been sent
    //      (if both sent timestamps are null, we don't show any highlight at all,
    //      just fall back to status-based color)
    else if (
        item?.interpreter_cancelled == 1 &&
        item?.status === 'available' &&
        minutesDiff !== null &&
        minutesDiff >= 0 &&
        minutesDiff <= 2880
    ) {
        style = { background: '#fff3cd' };
        blinkClass = "blink-container-yellow";
        highlightType = 'yellow';
    }
    else if (confirmationStatusNull && hasConfirmationSent) {
        if (
            minutesDiff !== null &&
            minutesDiff >= 0 &&
            minutesDiff <= 30 &&
            item?.status !== 'cancelled'
        ) {
            style = { background: '#ffcccc' };
            blinkClass = "blink-container";
            highlightType = 'red';
        }
        else if (
            minutesDiff !== null &&
            minutesDiff > 30 &&
            minutesDiff <= 720
        ) {
            style = { background: '#fff3cd' };
            highlightType = 'yellow';
        }
        // else: sent but outside the time window -> falls back to status color
    }
    // 3) Anything else (confirmation_status has some other value, OR
    //    confirmation_status is null but nothing has been sent yet) ->
    //    no override, stays as getBackgroundStyle(item?.status) from above.

    return { style, blinkClass, highlightType };
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [item, forceTick]);

    // Keep your existing VRI blink condition too, combine with new blink class
    const vriBlink = item?.type === "Video Remote Interpretation" &&
        item?.appointment_details?.video_platform === "external" &&
        !item?.appointment_details?.video_link &&
        item?.status !== "completed" &&
        item?.status !== "cancelled" &&
        item?.status !== "declined";

    const finalClassName = [
        vriBlink ? "blink-container" : "",
        rowStyle.blinkClass
    ].filter(Boolean).join(" ");


    console.log('itemsssss',item);
    return (
        <tr className={finalClassName}>
            {checkPermission('Detail Appointments') ?
                <td className='p-0' style={rowStyle.style}>
                    <div className={`eye_area  ${item?.appointment_details?.extra_mileage_request == 1 && 'extra-mileage'}`} style={getEyeStyle(item?.status, rowStyle.highlightType)}>
                        <Link to={`/appointments/view/${item?.id}`}><i class="fa-solid fa-eye"></i></Link>
                    </div>
                </td>
                :
                <td style={rowStyle.style}>
                    {serial}
                </td>}

            <td style={rowStyle.style}>
                {item?.appid || 'N/A'}
            </td>
            <td style={rowStyle.style} className='text-transform-capitalize '>
                {item?.status || 'N/A'}
            </td>
            <td style={rowStyle.style}>
                {item?.type || 'N/A'}
            </td>
            <td style={{...rowStyle.style, whiteSpace: 'nowrap' } }>
                {moment(item?.datetime, 'YYYY-MM-DD hh:mm A').format('MMM D, YYYY hh:mm A') || 'N/A'}
            </td>
            <td style={rowStyle.style}>
                {item?.language?.name || 'N/A'}
            </td>
            <td style={rowStyle.style}>
                {item?.interpreter?.user?.name || 'N/A'}
            </td>
            <td style={rowStyle.style}>
                {item?.accounts?.user?.name || 'N/A'}
            </td>
            <td style={rowStyle.style}>
                {item?.subclient?.subaccount_name || 'N/A'}
            </td>
            <td style={rowStyle.style}>
                {item?.status == 'available' &&
                    <Button
                        btnText={t("table.viewInvites")}
                        buttonType="button"
                        handleSubmit={() => handleInviteInterpreter(item)}
                    />
                }
            </td>
        </tr>
    )
})
export default ListTable